import { render, staticRenderFns } from "./VenueHours.vue?vue&type=template&id=375211a6"
import script from "./VenueHours.vue?vue&type=script&lang=js"
export * from "./VenueHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports